import React from "react";
import { connect } from "react-redux";
import ImageModal from "../../../../components/imageModal";
import * as types from "../../../../actions/actionTypes";
import { PremiumGuestAction } from "../../../../actions";

const GuestsDeniedModal = props => {
  const {
    modalData: { projectId, message },
    modalStatus,
    closeModal
  } = props;

  return (
    <ImageModal
      show={modalStatus}
      key={Math.random()}
      image={{
        src: "/images/access_denied_guest_users_illustration.svg",
        alt: "guests"
      }}
      closeHandler={closeModal}
      icon="mapsa-users-setting"
      title="کاربران مهمان در شرکت"
      description={message}
      rightButtons={[]}
      leftButtons={[
        {
          type: "ghost",
          borderless: false,
          onClick: closeModal,
          title: "متوجه شدم"
        },
        {
          type: "outline",
          borderless: true,
          onClick: () => {
            props.send(projectId);
            closeModal();
          },
          title: "ارسال درخواست تمدید طرح"
        }
      ]}
    />
  );
};

const mapStateToProps = store => {
  return {
    modalData: store.PremiumGuest.modalData,
    modalStatus: store.PremiumGuest.modalStatus
  };
};
const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => {
      dispatch(PremiumGuestAction.closeModal());
    },
    send: id => {
      dispatch({ type: types.WARN_OWNER_REQUEST, id });
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GuestsDeniedModal);
